import styled from "styled-components";

const Rep = styled.div`
  display: flex;
  align-items: baseline;
  cursor: pointer;
  padding-left: 8px;
  height: 45px;
  border-bottom: 1px solid #eee;
`;

export default Rep;
